import React from "react";
import { Outlet, useMatch } from 'react-router-dom';
import Header from '../../components/Header';
import Pagination from '../../components/Pagination';
import PaginationServices from '../../components/PaginationServices';
const Wrap = () => {
  
  const useCurrentPath = () => {
    const id = useMatch('/:id');
    if (id !== null && id.params.id !== undefined) {
      return id.params.id;
    }
    return 'main';
  }
  const currentPath = useCurrentPath().toLowerCase();
  let pagination = null;
  switch (currentPath) {
    case 'main':
      pagination = <Pagination />
      break;
    case 'compare':
      pagination = <Pagination />
      break;
    case 'services':
      pagination = <PaginationServices />
      break;
    default:
      break;
  }

  return (
    <>
      <div className="wrap">
        <Header/>
        <Outlet />
        {pagination}
      </div>
    </>
  );

}

export default Wrap;
